import React from "react";
import { mern_projects, static_projects, android_projects } from "./data";
export default function Projects() {
  return (
    <div className="flex bg-gray-900 w-fit">
      <div className="sticky top-0 h-screen mx-0 rounded-r-3xl md:flex hidden w-2/6 justify-center items-center bg-white">
        <h1 className="text-black text-5xl text-center font-bold tracking-widest ">
          {"~"} PROJECTS
        </h1>
      </div>
      <div className="flex flex-1 flex-col p-5 gap-5 pt-9">
        {/* MERN info */}
        <div className="flex flex-col h-auto">
          <h1 className="text-xl font-bold text-white">- MERN Stack</h1>
          <div className="flex gap-5 p-4 flex-wrap md:items-start md:justify-normal justify-center items-center">
            {mern_projects.map((details, i) => (
              <Card key={i} details={details} />
            ))}
          </div>
        </div>
        {/* android info */}
        <div className="flex flex-col h-auto">
          <h1 className="text-xl font-bold text-white">- ANDROID NATIVE</h1>
          <div className="flex gap-5 p-4 flex-wrap md:items-start md:justify-normal justify-center items-center">
            {android_projects.map((details, i) => (
              <Card key={i} details={details} />
            ))}
          </div>
        </div>
        {/* Static info */}
        <div className="flex flex-col h-auto lg:pb-10 md:pb-10 pb-28">
          <h1 className="text-xl font-bold text-white">- STATIC SITE</h1>
          <div className="flex gap-5 p-4 flex-wrap md:items-start md:justify-normal justify-center items-center">
            {static_projects.map((details, i) => (
              <Card key={i} details={details} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

{
  /* // card */
}
function Card({ details }) {
  let { title, description, link, img } = details;
  return (
    <div
      style={{
        maxHeight: "460px",
      }}
      className="relative flex flex-col border rounded-lg border-yellow-500 duration-500 ease-in overflow-hidden  transition-all h-60 hover:h-full w-72 "
    >
      {/* image */}
      <div className="w-full min-h-[250px] bg-white flex justify-center items-center">
        <img alt="classbazzar" className=" object-fill" src={img} />
      </div>
      {/* details */}
      <div className="text-white flex gap-3 flex-col py-4 px-2">
        <h1 className="text-2xl text-center">{title}</h1>
        <p className="text-base ">{description}</p>
        <a
          href={link}
          className="absolute bottom-2 right-3"
          target="_blank"
          rel="noreferrer"
        >
          <div className="bg-yellow-500 border-none rounded-full p-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-4 h-4"
            >
              <path
                fillRule="evenodd"
                d="M15.75 2.25H21a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V4.81L8.03 17.03a.75.75 0 0 1-1.06-1.06L19.19 3.75h-3.44a.75.75 0 0 1 0-1.5Zm-10.5 4.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V10.5a.75.75 0 0 1 1.5 0v8.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h8.25a.75.75 0 0 1 0 1.5H5.25Z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </a>
      </div>
    </div>
  );
}
